import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { TDR } from 'tdr-common';
import CTALink from '../../components/buttons/CTALink';
import ErrorIcon from '../../icons/error-grey.svg';
import { ResultPageLayout } from '../../layouts/ResultPageLayout';
import { analytics, BOOKING_CONFIRMATION_TIMEOUT } from '../../helpers/analytics';
import { useTranslation } from 'react-i18next';

type ConfirmationTimeoutProps = {
	sessionId: string;
	restaurantSlug: string;
};

export const ConfirmationTimeout = ({ sessionId, restaurantSlug }: ConfirmationTimeoutProps) => {
	const location = useLocation();
	const { t } = useTranslation();

	const needHelpHref = `mailto:${TDR.SUPPORT_EMAIL}?subject=Need help with checkout sessionID: ${sessionId}`;
	const returnHomeHref = `/${restaurantSlug}/explore`;

	useEffect(() => {
		analytics.track(BOOKING_CONFIRMATION_TIMEOUT, {
			...location
		});
	}, []);

	return (
		<ResultPageLayout headerIcon={ErrorIcon}>
			<ResultPageLayout.Title>{t('titles.oops')}</ResultPageLayout.Title>

			<ResultPageLayout.Body>
				<p>{t('error_pages.confirmation_timeout')}</p>
			</ResultPageLayout.Body>

			<ResultPageLayout.Footer>
				<CTALink text={t('actions.get_help')} to={needHelpHref} />
				<CTALink text={t('actions.return_to_booking_portal')} to={returnHomeHref} variant='dark' />
			</ResultPageLayout.Footer>
		</ResultPageLayout>
	);
};
